import { deepmerge } from "./isMergeableObject"

//const webServer = "https://vpweb.thevantagepoint.com/VPWeb/VPWebServer.php"
const webServer = "https://patstat.org/VPWeb/VPWebServer.php"
//const webServer = "http://localhost/VPWebServer.php?";
let ListBlocks = 1000
let MatrixBlocks = 100
const DatasetsAvailable = async (url = webServer, userName, userPassword, serverName, signal) => {
	var command = '"command":"ProcessCommand"'
	var DataName = '"CommandName":"VpWebPublisher"'
	return fetch(url + "?", {
		signal,
		method: "post",
		mode: "cors",
		headers: {
			"Accept-Encoding":"gzip, deflate",
			"Content-Type": "application/x-www-form-urlencoded"
		},
		body: "command={" + command + "," + DataName + "}"
	})
	/*var oFunctionArgs = {
		Username: userName,
		userPassword: userPassword,
		Server: serverName,
		Command: "GetPublishedDatasets"
	}
	var oArgsForProcess = {};
	oArgsForProcess.command		= 'ProcessCommand';
	oArgsForProcess.CommandName	= 'VpWebPublisher';
	oArgsForProcess.Arguments	= JSON.stringify(oFunctionArgs);
	*/
	try {
		let response = await fetch(url, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: "query='System.Datasets'"
		})
		let status = await response.status
		if (status !== 200){
			console.log("Looks like there was a problem. Status Code: " + status)
		}
		//.then(response => {
		//	return response.text()})
		let data = await response.text()
		return JSON.parse(data).results
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting dataset details")
			return {}
		}
		console.warn("Fetch Error :-S", error)
		return null
	}

}
const DatasetDetails = (url = webServer, datasetID, signal) => {
	return new Promise((resolve) => {
		var command = "query"
		var strQuery = "query Dataset.SheetNames ReturnObjects"
		return fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
			.then(response => {
				return response.text()})
			.then(data=> {
				resolve(parseResponse(data))})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting dataset details")
					return {}
				}
				console.warn("Fetch Error :-S", error)
				return null
			})
	})
}
const DatasetDetailsAsync = async (url = webServer, datasetID, signal) => {
	try {
		var command = "query"
		var strQuery = "query Dataset.SheetNames, Dataset.RecordCount, Dataset.ID ReturnObjects"
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
		let status = await response.status
		if (status !== 200){
			console.log("Looks like there was a problem. Status Code: " + status)
		}
		//.then(response => {
		//	return response.text()})
		let data = await response.text()
		return parseResponse(data)
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting dataset details")
			return {}
		}
		console.warn("Fetch Error :-S", error)
		return null
	}
}
const BrowserContents = (url = webServer, URL, signal) => {
	return new Promise((resolve) => {
		return fetch(URL, {
			signal,
			method: "GET",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
			}
		})
			.then(response => {
				return response.text()})
			.then(data=> {
				resolve(parseResponse(data))})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting browser contents")
					return {}
				}
				console.warn("Fetch Error :-S", error)
				return null
			})
	})
}
const GetDataStoredInDataset = (url = webServer, datasetID, Data, returnType, signal) => {
	return new Promise((resolve) => {
		var command = "\"command\":\"GetDataStoredInDataset\""
		var DataName = "\"DataName\":\"" + Data + "\""
		return fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: "command={" + command + "," + DataName + "}"
		})
			.then(response => {
				return response.text()
			})
			.then(data => {
				resolve(parseResponse(data))
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting stored data")
					return {}
				}
				console.warn("Fetch Error :-S", error)
				return null
			})
	})
}

const GetDataStoredInDatasetAsync = async (url = webServer, datasetID, Data, returnType, signal) => {
	try {
		var command = "\"command\":\"GetDataStoredInDataset\""
		var DataName = "\"DataName\":\"" + Data + "\""
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: "command={" + command + "," + DataName + "}"
		})
		let data = await response.text()
		return parseResponse(data)
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting stored data")
			return {}
		}
		console.warn("Fetch Error :-S", error)
		return null
	}
}

const FieldedRecordView = (url = webServer, datasetID, recordArray, signal) => {
	return new Promise((resolve) => {
		var command = "query"
		var Records = recordArray.map(x => " record=" + x)
		var summary = "query RecordViewWeb.Summary returnObjects"
		var strQuery = "query RecordViewWeb.TextToDisplay where" + Records.join(" or") + " returnObjects"
		var ReturnData = {}
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + summary
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " +
						response.status)
					return
				}
				// Examine the text in the response
				response.json().then((RecordSummary) => {
					if (RecordSummary.error === "0") {
						fetch(url + "?" + "VpPubId=" + datasetID, {
							signal,
							method: "post",
							mode: "cors",
							headers: {
								"Accept-Encoding":"gzip, deflate",
								"Content-Type": "application/x-www-form-urlencoded"
							},
							body: command + "=" + strQuery
						})
							.then(response => {
								if (response.status !== 200) {
									console.log("Looks like there was a problem. Status Code: " +
										response.status)
									return
								}
								// Examine the text in the response
								response.json().then((RecordData) => {
									if (RecordData.error === "0") {
										ReturnData.Summary = parseResponse(RecordSummary)
										ReturnData.RecordData = parseResponse(RecordData)
										resolve(ReturnData)
									}
									else {
										console.log(RecordData.error, RecordData.results)
									}
								})
							})
							.catch(error => {
								console.warn("Fetch Error :-S", error)
								return null
							})
					}
					else {
						console.log(RecordSummary.error, RecordSummary.results)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting fielded record")
					return {}
				}
				console.warn("Fetch Error :-S", error)
				return null
			})
	})
}

const RawRecordField = (url = webServer, datasetID, recordArray, signal) => {
	return new Promise((resolve) => {
		var ReturnData = []
		var command = "query"
		for (let i=0; i < recordArray.length; i++){

			var strQuery = "query item.name where field.datatype='Link' and record=" + recordArray[i]
			fetch(url + "?" + "VpPubId=" + datasetID, {
				signal,
				method: "post",
				mode: "cors",
				headers: {
					"Accept-Encoding":"gzip, deflate",
					"Content-Type": "application/x-www-form-urlencoded"
				},
				body: command + "=" + strQuery
			})
				.then(response => {
					if (response.status !== 200) {
						console.log("Looks like there was a problem. Status Code: " +
					response.status)
						return
					}
					// Examine the text in the response
					response.json().then((LinkField) => {
						if (LinkField.error === "0"){

							ReturnData.push(parseResponse(LinkField))
							if (ReturnData.length === recordArray.length) {
								resolve(ReturnData)
							}
						}
						else {
							console.log(LinkField.error, LinkField.results)
						}
					})
				})
				.catch(error => {
					if (error.name == "AbortError"){
						console.log("aborting raw record")
						return {}
					}
				})
		}
	})
}

const DetailWindowData = function (url = webServer, datasetID, DetailViewID, MainViewFieldID, mainPanelSelection, BrowserSelectString, signal) {
	let DetailBlocks = 100
	return new Promise((resolve) => {
		var ReturnData = {}
		var command = "query"
		let strQuery
		if (BrowserSelectString !== undefined){
			strQuery = "query DetailView.Summary where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString + "='" + mainPanelSelection.selectedIDs + "' ReturnObjects"
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " item=" + x)
			strQuery = "query DetailView.Summary where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") + " ReturnObjects"
		}
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " + response.status)
					return
				}
				// Examine the text in the response
				response.json().then(data1 => {
					if (data1.error === "0"){
						let DetailWindowSummaryData = parseResponse(data1)
						for (var detailInfo in DetailWindowSummaryData) {
							var RowCount = (typeof DetailWindowSummaryData[detailInfo].RowCount === "undefined") ? "" : parseInt(DetailWindowSummaryData[detailInfo].RowCount, 10)
						}
						var DetailObj = {}                                        
						var HeaderInfo = {
							RowCount: RowCount
						}
						ReturnData.HeaderInfo = HeaderInfo
						if (RowCount === 0){
							ReturnData.List = []
							resolve(ReturnData)
						}
						else {
						
							for (let index = 0; index < RowCount; index += DetailBlocks) {
								let detailQuery
								if (BrowserSelectString !== undefined){
									detailQuery = "query DetailView.Item where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString + "='" + mainPanelSelection.selectedIDs + "' Row=" + index + " count=" + DetailBlocks + " sort=RecDesc ReturnObjects"
								}
								else {
									detailQuery = "query DetailView.Item where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") + " Row=" + index + " count=" + DetailBlocks + " sort=RecDesc ReturnObjects"
								}
								fetch(url + "?" + "VpPubId=" + datasetID, {
									signal,
									method: "post",
									mode: "cors",
									headers: {
										"Accept-Encoding":"gzip, deflate",
										"Content-Type": "application/x-www-form-urlencoded"
									},
									body: command + "=" + detailQuery
								})
									.then(response => {
										if (response.status !== 200) {
											console.log("Looks like there was a problem. Status Code: " +
									response.status)
											return
										}
										// Examine the text in the response
										response.json().then((DetailData) => {
											if (DetailData.error === "0"){

												if (DetailObj === {}){
													DetailObj = parseResponse(DetailData)
												}
												else {
													DetailObj = deepmerge(DetailObj, parseResponse(DetailData))
												}
											}
											else {
												console.log(DetailData.error, DetailData)
											}
											if (Object.keys(DetailObj.RowLabels).length >= RowCount*3) {
												ReturnData.List = DetailObj
												resolve(ReturnData)
											}
										})
									})
									.catch(error => {
										if (error.name == "AbortError"){
											console.log("aborting Detail Items")
											return {}
										}
										console.log("Fetch Error :-S", error)
									})
							}
						}
					}
					else {
						console.log(data1.error, data1.results)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Detail Summary")
					return 0
				}
		  console.error("There has been a problem with your fetch operation:", error)
			})
	})
}

const DetailWindowSummary = function (url = webServer, datasetID, DetailViewID, MainViewFieldID, mainPanelSelection, BrowserSelectString, signal) {
	return new Promise((resolve) => {
		var ReturnData = {}
		var command = "query"
		let strQuery
		if (BrowserSelectString !== undefined){
			if (mainPanelSelection.selectedIDs !== ""){
				strQuery = "query DetailView.Summary where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString + "='" + mainPanelSelection.selectedIDs + "' ReturnObjects"
			}
			else {
				resolve(0)
			}
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " item=" + x)
			strQuery = "query DetailView.Summary where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") + " ReturnObjects"
		}
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " + response.status)
					return
				}
				// Examine the text in the response
				response.json().then(data1 => {
					if (data1.error === "0"){
						let DetailWindowSummaryData = parseResponse(data1)
						for (var detailInfo in DetailWindowSummaryData) {
							var RowCount = (typeof DetailWindowSummaryData[detailInfo].RowCount === "undefined") ? "" : parseInt(DetailWindowSummaryData[detailInfo].RowCount, 10)
						}
						resolve(RowCount)
					}
					else {
						console.log(data1.error, data1)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Detail Summary")
					return 0
				}
		  console.error("There has been a problem with your fetch operation:", error)
			})
	})
}

const DetailWindowSummaryAsync = async function (url = webServer, datasetID, DetailViewID, MainViewFieldID, mainPanelSelection, BrowserSelectString, signal) {
	try {
		var command = "query"
		let strQuery
		if (BrowserSelectString !== undefined){
			if (mainPanelSelection.selectedIDs !== ""){
				strQuery = "query DetailView.Summary where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString + "='" + mainPanelSelection.selectedIDs + "' ReturnObjects"
			}
			else {
				return 0
			}
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " item=" + x)
			strQuery = "query DetailView.Summary where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") + " ReturnObjects"
		}
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
		let status = await response.status
		if (status !== 200) {
			console.log("Looks like there was a problem. Status Code: " + status)
			return
		}
		// Examine the text in the response
		let data1 = await response.json()
		if (data1.error === "0"){
			let DetailWindowSummaryData = parseResponse(data1)
			for (var detailInfo in DetailWindowSummaryData) {
				var RowCount = (typeof DetailWindowSummaryData[detailInfo].RowCount === "undefined") ? "" : parseInt(DetailWindowSummaryData[detailInfo].RowCount, 10)
			}
			return RowCount
		}
		else {
			console.log(data1.error, data1)
		}
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Detail Summary")
			return 0
		}
		console.error("There has been a problem with your fetch operation:", error)
	}
}

const DetailWindowItems = function (url = webServer, datasetID, DetailViewID, MainViewFieldID, mainPanelSelection, BrowserSelectString, index, DetailBlocks, signal) {
	return new Promise((resolve) => {
		let DetailObj = {}
		let detailQuery
		var command = "query"
		if (BrowserSelectString !== undefined){
			detailQuery = "query DetailView.Item where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString + "='" + mainPanelSelection.selectedIDs + "' Row=" + index + " count=" + DetailBlocks + " sort=RecDesc ReturnObjects"
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " item=" + x)
			detailQuery = "query DetailView.Item where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") + " Row=" + index + " count=" + DetailBlocks + " sort=RecDesc ReturnObjects"
		}
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + detailQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " +
				response.status)
					return
				}
				// Examine the text in the response
				response.json().then((DetailData) => {
					if (DetailData.error === "0"){
						DetailObj = parseResponse(DetailData)
						resolve(DetailObj)
					}
					else {
						console.log(DetailData.error, DetailData)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Detail Items")
					return {}
				}
				console.log("Fetch Error :-S", error)
			})
	})
}

const DetailWindowItemsAsync = async function (url = webServer, datasetID, DetailViewID, MainViewFieldID, mainPanelSelection, BrowserSelectString, index, DetailBlocks, sortBy, signal) {
	try {
		let DetailObj = {}
		let detailQuery
		var command = "query"
		if (BrowserSelectString !== undefined){
			detailQuery = `query DetailView.Item where field.id=${DetailViewID} SelectFromView=${MainViewFieldID} ${BrowserSelectString}='${mainPanelSelection.selectedIDs}' Row=${index} count=${DetailBlocks} sort=${sortBy} ReturnObjects`
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " item=" + x)
			detailQuery = `query DetailView.Item where field.id=${DetailViewID} SelectFromView=${MainViewFieldID}${SelectedString.join("")} Row=${index} count=${DetailBlocks} sort=${sortBy} ReturnObjects`
		}
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + detailQuery
		})
		let status = await response.status
		if (status !== 200) {
			console.log("Looks like there was a problem. Status Code: " +
			status)
			return {}
		}
		// Examine the text in the response
		let DetailData = await response.json()
		if (DetailData.error === "0"){
			DetailObj = parseResponse(DetailData)
			return DetailObj
		}
		else {
			console.log(DetailData.error, DetailData)
			return {}
		}
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Detail Items")
			return {}
		}
		console.log("Fetch Error :-S", error)
		return {}
	}
}
					

const DetailWindowRecords = function (url = webServer, datasetID, DetailViewID, MainViewFieldID, mainPanelSelection, highlight, RowCount, signal) {
	return new Promise((resolve) => {
		var ReturnData = {}
		var command = "query"

		let SelectedString = ""
		if (mainPanelSelection.browserSelectString !== undefined){
			SelectedString = mainPanelSelection.browserSelectString + "='" + mainPanelSelection.selectedIDs + "'"
		}
		else {
			SelectedString = mainPanelSelection.selectedIDs.map(x => " Item=" + x)
		}
		var HighlightString = highlight.map(x => " highlight=" + x)
		var DetailObj = {}
		//for (var index = 0; index < RowCount; index += DetailBlocks) {
		var detailQuery = "query DetailView.Records where field.id=" + DetailViewID + " SelectFromView=" + MainViewFieldID + " " + SelectedString + HighlightString.join("") + " ReturnObjects"
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + detailQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " + response.status)
					return
				}
				// Examine the text in the response
				response.json().then((DetailData) => {
					if (DetailData.error === "0"){
						const DetailDataResults = parseResponse(DetailData)
						for (var prop in DetailDataResults){
							if (DetailDataResults.hasOwnProperty(prop)){
								DetailObj = JSON.parse(DetailDataResults[prop].recs)
								
								resolve(DetailObj)
							}
						}
					}
					else {
						console.log(DetailData.error, DetailData)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Detail Records")
					return {}
				}
				console.log("Fetch Error :-S", error)
			})
		//}
	})
}

const TitleWindowData = function (url = webServer, datasetID, TitleFieldID, MainViewFieldID, mainPanelSelection, BrowserSelectString, signal) {
	let TitleWindowBlocks = 100
	return new Promise((resolve) => {
		var ReturnData = {}
		var command = "query"
		let strQuery
		if (BrowserSelectString !== undefined){
			strQuery = "query TitleView.Summary where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString + "='" + mainPanelSelection.selectedIDs + "' ReturnObjects"
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " Item=" + x)
			strQuery = "query TitleView.Summary where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") + " ReturnObjects"
		}
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " +
                response.status)
					return
				}
				// Examine the text in the response
				response.json().then(data1 => {
					if (data1.error === "0"){
						const TitleViewSummary = parseResponse(data1)
						for (var titleInfo in TitleViewSummary) {
							var RowCount = (typeof TitleViewSummary[titleInfo].RowCount === "undefined") ? "" : parseInt(TitleViewSummary[titleInfo].RowCount, 10)
						}
						let TitleObj = {}                                  
						var HeaderInfo = {
							RowCount: RowCount
						}
						ReturnData.HeaderInfo = HeaderInfo
						for (var index = 0; index < RowCount; index += TitleWindowBlocks) {
							let titleQuery
							if (BrowserSelectString !== undefined){
								titleQuery = "query TitleView.Item where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString +  "='" + mainPanelSelection.selectedIDs + "' Row=" + index + " sort=recdesc count=" + TitleWindowBlocks + " ReturnObjects"
							}
							else {
								titleQuery = "query TitleView.Item where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") +  " Row=" + index + " sort=recdesc count=" + TitleWindowBlocks + " ReturnObjects"
							}
							fetch(url + "?" + "VpPubId=" + datasetID, {
								signal,
								method: "post",
								mode: "cors",
								headers: {
									"Accept-Encoding":"gzip, deflate",
									"Content-Type": "application/x-www-form-urlencoded"
								},
								body: command + "=" + titleQuery
							})
								.then(response => {
									if (response.status !== 200) {
										console.log("Looks like there was a problem. Status Code: " +
									response.status)
										return
									}
									// Examine the text in the response
									response.json().then((TitleData) => {
										if (TitleData.error === "0"){
											if (TitleObj === {}){
												TitleObj = parseResponse(TitleData)
											}
											else {
												TitleObj = deepmerge(TitleObj, parseResponse(TitleData))
											}
										}
										else {
											console.log(TitleData.error, TitleData)
										}
										if (Object.keys(TitleObj.RowLabels).length >= RowCount*3) {
											ReturnData.List = TitleObj
											resolve(ReturnData)
										}
									})
								})
								.catch(error => {
									if (error.name == "AbortError"){
										console.log("aborting Title Items")
										return {}
									}
									console.log("Fetch Error :-S", error)
								})
						}
					}
					else {
						console.log(data1.error, data1)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Title Summary")
					return 0
				}
				console.log("Fetch Error :-S", error)
			})
	})
}

const TitleWindowSummary = function (url = webServer, datasetID, TitleFieldID, MainViewFieldID, mainPanelSelection, BrowserSelectString, signal) {
	return new Promise((resolve) => {
		var command = "query"
		let strQuery
		if (BrowserSelectString !== undefined){
			if (mainPanelSelection.selectedIDs !== ""){

				strQuery = "query TitleView.Summary where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString + "='" + mainPanelSelection.selectedIDs + "' ReturnObjects"
			}
			else {
				resolve(0)
			}
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " Item=" + x)
			strQuery = "query TitleView.Summary where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") + " ReturnObjects"
		}
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " +
			response.status)
					return
				}
				// Examine the text in the response
				response.json().then(data1 => {
					if (data1.error === "0"){
						const TitleViewSummary = parseResponse(data1)
						for (var titleInfo in TitleViewSummary) {
							var RowCount = (typeof TitleViewSummary[titleInfo].RowCount === "undefined") ? "" : parseInt(TitleViewSummary[titleInfo].RowCount, 10)
						}
						resolve(RowCount)
					}
					else {
						console.log(data1.error, data1)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Title Summary")
					return 0
				}
				console.log("Fetch Error :-S", error)
			})
	})
}
const TitleWindowSummaryAsync = async function (url = webServer, datasetID, TitleFieldID, MainViewFieldID, mainPanelSelection, BrowserSelectString, signal) {
	try {
		var command = "query"
		let strQuery
		if (BrowserSelectString !== undefined){
			if (mainPanelSelection.selectedIDs !== ""){

				strQuery = "query TitleView.Summary where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString + "='" + mainPanelSelection.selectedIDs + "' ReturnObjects"
			}
			else {
				return 0
			}
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " Item=" + x)
			strQuery = "query TitleView.Summary where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") + " ReturnObjects"
		}
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
		let status = await response.status
		if (status !== 200) {
			console.log("Looks like there was a problem. Status Code: " +
		status)
			return
		}
		// Examine the text in the response
		let data1 = await response.json()
		if (data1.error === "0"){
			const TitleViewSummary = parseResponse(data1)
			for (var titleInfo in TitleViewSummary) {
				var RowCount = (typeof TitleViewSummary[titleInfo].RowCount === "undefined") ? "" : parseInt(TitleViewSummary[titleInfo].RowCount, 10)
			}
			return RowCount
		}
		else {
			console.log(data1.error, data1)
		}
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Title Summary")
			return 0
		}
		console.log("Fetch Error :-S", error)
	}
}
const TitleWindowItems = function (url = webServer, datasetID, TitleFieldID, MainViewFieldID, mainPanelSelection, BrowserSelectString, startIndex, TitleWindowBlocks, signal) {
	return new Promise((resolve) => {
		let titleQuery
		var command = "query"
		if (BrowserSelectString !== undefined){
			titleQuery = "query TitleView.Item where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + " " + BrowserSelectString +  "='" + mainPanelSelection.selectedIDs + "' Row=" + startIndex + " sort=recdesc count=" + TitleWindowBlocks + " ReturnObjects"
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " Item=" + x)
			titleQuery = "query TitleView.Item where field.id=" + TitleFieldID + " SelectFromView=" + MainViewFieldID + "" + SelectedString.join("") +  " Row=" + startIndex + " sort=recdesc count=" + TitleWindowBlocks + " ReturnObjects"
		}
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + titleQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " +
				response.status)
					return
				}
				let TitleObj = {}
				// Examine the text in the response
				response.json().then((TitleData) => {
					if (TitleData.error === "0"){
						TitleObj = parseResponse(TitleData)
					}
					else {
						console.log(TitleData.error, TitleData)
					}
					resolve(TitleObj)
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Title Items")
					return {}
				}
				console.log("Fetch Error :-S", error)
			})
	})
}

const TitleWindowItemsAsync = async function (url = webServer, datasetID, TitleFieldID, MainViewFieldID, mainPanelSelection, BrowserSelectString, startIndex, TitleWindowBlocks, sortBy, signal) {
	try {
		let titleQuery
		var command = "query"
		if (BrowserSelectString !== undefined){
			titleQuery = `query TitleView.Item where field.id=${TitleFieldID} SelectFromView=${MainViewFieldID} ${BrowserSelectString}="${mainPanelSelection.selectedIDs}" Row=${startIndex} sort=${sortBy} count=${TitleWindowBlocks} ReturnObjects`
		}
		else {
			var SelectedString = mainPanelSelection.selectedIDs.map(x => " Item=" + x)
			titleQuery = `query TitleView.Item where field.id=${TitleFieldID} SelectFromView=${MainViewFieldID}${SelectedString.join("")} Row=${startIndex} sort=${sortBy} count=${TitleWindowBlocks} ReturnObjects`
		}
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + titleQuery
		})
		let status = await response.status
		if (status !== 200) {
			console.log("Looks like there was a problem. Status Code: " +
			response.status)
			return
		}
		let TitleObj = {}
		// Examine the text in the response
		let TitleData = await response.json()
		if (TitleData.error === "0"){
			TitleObj = parseResponse(TitleData)
		}
		else {
			console.log(TitleData.error, TitleData)
		}
		return TitleObj
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Title Items")
			return {}
		}
		console.log("Fetch Error :-S", error)
	}
}

const ListViewData = function (url = webServer, datasetID, ListViewID, signal) {
	return new Promise((resolve) => {
		var ReturnData = {}
		var command = "query"
		var strQuery = "query ListView.Summary where ListView=" + ListViewID + " ReturnObjects"
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " +
                        response.status)
					return
				}
				// Examine the text in the response
				response.json().then(data1 => {
					if (data1.error === "0"){

						let ListViewSummaryData = parseResponse(data1)
						let groupArr = []
						if (ListViewSummaryData[Object.keys(ListViewSummaryData)[0]].FieldType[0] === "parent"){
							let GroupCount = ""
							let ItemCount = ""
							let ViewName = ""
							let FieldType = ""
							let ChildFieldCount = ""
							for (let listInfo in ListViewSummaryData) {
								GroupCount = (typeof ListViewSummaryData[listInfo].GroupCount === "undefined") ? "" : parseInt(ListViewSummaryData[listInfo].GroupCount, 10)
								ItemCount = (typeof ListViewSummaryData[listInfo].ItemCount === "undefined") ? "" : parseInt(ListViewSummaryData[listInfo].ItemCount, 10)
								ViewName = (typeof ListViewSummaryData[listInfo].ViewName === "undefined") ? "" : String(ListViewSummaryData[listInfo].ViewName)
								FieldType = (typeof ListViewSummaryData[listInfo].FieldType === "undefined") ? "" : String(ListViewSummaryData[listInfo].FieldType)
								ChildFieldCount = (typeof ListViewSummaryData[listInfo].ChildFieldCount === "undefined") ? "" : parseInt(ListViewSummaryData[listInfo].ChildFieldCount, 10)
								for (var i = 0; i < GroupCount; i++) {
									groupArr.push({
										key: i,
										groupID: ListViewSummaryData[listInfo]["GroupID" + String(i)],
										groupName: ListViewSummaryData[listInfo]["GroupName" + String(i)]
									})
								}
								var ChildFieldNames = []
								for (var childField=0; childField<ChildFieldCount; childField++){ 
									if (ListViewSummaryData[listInfo].hasOwnProperty("ChildField" + childField)){
										ChildFieldNames.push(ListViewSummaryData[listInfo]["ChildField" + String(childField)][0])
									}
								}
							}
							let data = []                                        
							let HeaderInfo = {
								RecordCount: "# Records",
								InstanceCount: "# Instances",
								Name: ViewName.split("::")[1],
								ChildFieldNames: ChildFieldNames,
								GroupArr: groupArr,
								GroupCount: groupArr.length,
								RowCount: ItemCount,
								FieldType: FieldType,
								ChildFieldCount: ChildFieldCount
							}
							ReturnData.HeaderInfo = HeaderInfo
							let FullListObject = {}
							for (var index = 0; index < ItemCount; index += ListBlocks) {
								var listQuery = "query ListView.Item where ListView=" + ListViewID + " sort=RecDesc Row=" + index + " count=" + ListBlocks + " ReturnObjects"
								fetch(url + "?" + "VpPubId=" + datasetID, {
									signal,
									method: "post",
									mode: "cors",
									headers: {
										"Accept-Encoding":"gzip, deflate",
										"Content-Type": "application/x-www-form-urlencoded"
									},
									body: command + "=" + listQuery
								})
									.then(response => {
										if (response.status !== 200) {
											console.log("Looks like there was a problem. Status Code: " +
										response.status)
											return
										}
										// Examine the text in the response
										response.json().then((ListData) => {
											if(ListData.error === "0"){

												if (FullListObject !== {}){
													FullListObject = deepmerge(FullListObject, parseResponse(ListData))
												}
												else {
													FullListObject = parseResponse(ListData)
												}
											}
											else {
												console.log(ListData.error, ListData)
											}
											if (Object.keys(FullListObject).length === ItemCount) {
											//Object.keys(data).sort(function (a, b) {
												//    return parseInt(a.ListRank, 10) - parseInt(b.ListRank, 10);
												//});
												//ReturnData.List = data
												ReturnData.ListObject = FullListObject
												resolve(ReturnData)
											}
										})
									})
									.catch(error => {
										if (error.name == "AbortError"){
											console.log("aborting List Items")
											return {}
										}
										console.log("Fetch Error :-S", error)
									})
							}
						}
						else {
							let GroupCount = ""
							let ItemCount = ""
							let ViewName = ""
							let FieldType = ""
							for (let listInfo in ListViewSummaryData) {
								GroupCount = (typeof ListViewSummaryData[listInfo].GroupCount === "undefined") ? "" : parseInt(ListViewSummaryData[listInfo].GroupCount, 10)
								ItemCount = (typeof ListViewSummaryData[listInfo].ItemCount === "undefined") ? "" : parseInt(ListViewSummaryData[listInfo].ItemCount, 10)
								ViewName = (typeof ListViewSummaryData[listInfo].ViewName === "undefined") ? "" : String(ListViewSummaryData[listInfo].ViewName)
								FieldType = (typeof ListViewSummaryData[listInfo].FieldType === "undefined") ? "" : String(ListViewSummaryData[listInfo].FieldType)
								for (let i = 0; i < GroupCount; i++) {
									groupArr.push({
										key: i,
										groupID: ListViewSummaryData[listInfo]["GroupID" + String(i)],
										groupName: ListViewSummaryData[listInfo]["GroupName" + String(i)]
									})
								}
							}
							let data = []                                        
							let HeaderInfo = {
								RecordCount: "# Records",
								InstanceCount: "# Instances",
								Name: ViewName.split("::")[1],
								ChildFieldNames: "",
								GroupArr: groupArr,
								GroupCount: groupArr.length,
								RowCount: ItemCount,
								FieldType: FieldType,
								ChildFieldCount: 0
							}
							ReturnData.HeaderInfo = HeaderInfo
							let FullListObject = {}
							for (let index = 0; index < ItemCount; index += ListBlocks) {
								let listQuery = "query ListView.Item where ListView=" + ListViewID + " sort=RecDesc Row=" + index + " count=" + ListBlocks + " ReturnObjects"
								fetch(url + "?" + "VpPubId=" + datasetID, {
									signal,
									method: "post",
									mode: "cors",
									headers: {
										"Accept-Encoding":"gzip, deflate",
										"Content-Type": "application/x-www-form-urlencoded"
									},
									body: command + "=" + listQuery
								})
									.then(response => {
										if (response.status !== 200) {
											console.log("Looks like there was a problem. Status Code: " +
											response.status)
											return
										}
										// Examine the text in the response
										response.json().then((ListData) => {
											if(ListData.error === "0"){

												if (FullListObject !== {}){
													FullListObject = deepmerge(FullListObject, parseResponse(ListData))
												}
												else {
													FullListObject = parseResponse(ListData)
												}
											}
											else {
												console.log(ListData.error, ListData)
											}
											if (Object.keys(FullListObject).length === ItemCount) {
												//Object.keys(data).sort(function (a, b) {
												//    return parseInt(a.ListRank, 10) - parseInt(b.ListRank, 10);
												//});
												//ReturnData.List = data
												ReturnData.ListObject = FullListObject
												resolve(ReturnData)
											}
										})
									})
									.catch(error => {
										if (error.name == "AbortError"){
											console.log("aborting List Items")
											return {}
										}
										console.log("Fetch Error :-S", error)
									})
							}
						}
					}
					else {
						console.log(data1.error, data1)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting List Summary")
					return 0
				}
				console.log("Fetch Error :-S", error)
			})
	})
}

const ListViewDataAsync = async function (url = webServer, datasetID, ListViewID, signal) {
	try {
		var command = "query"
		var strQuery = "query ListView.Summary where ListView=" + ListViewID + " ReturnObjects"
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
		let status = await response.status
		if (status !== 200) {
			console.log(`Looks like there was a problem. Status Code: ${status}`)
			return
		}
		// Examine the text in the response
		let ListData = await response.json()
		if (ListData.error === "0"){

			let ListViewSummaryData = parseResponse(ListData)
			let groupArr = []
			let GroupCount = ""
			let ItemCount = ""
			let ViewName = ""
			let FieldType = ""
			let ChildFieldCount = ""
			for (let listInfo in ListViewSummaryData) {
				GroupCount = (typeof ListViewSummaryData[listInfo].GroupCount === "undefined") ? "" : parseInt(ListViewSummaryData[listInfo].GroupCount, 10)
				ItemCount = (typeof ListViewSummaryData[listInfo].ItemCount === "undefined") ? "" : parseInt(ListViewSummaryData[listInfo].ItemCount, 10)
				ViewName = (typeof ListViewSummaryData[listInfo].ViewName === "undefined") ? "" : String(ListViewSummaryData[listInfo].ViewName)
				FieldType = (typeof ListViewSummaryData[listInfo].FieldType === "undefined") ? "" : String(ListViewSummaryData[listInfo].FieldType)
				ChildFieldCount = (typeof ListViewSummaryData[listInfo].ChildFieldCount === "undefined") ? 0 : parseInt(ListViewSummaryData[listInfo].ChildFieldCount, 10)
				for (var i = 0; i < GroupCount; i++) {
					groupArr.push({
						key: i,
						groupID: ListViewSummaryData[listInfo][`GroupID${String(i)}`],
						groupName: ListViewSummaryData[listInfo][`GroupName${String(i)}`]
					})
				}
				var ChildFieldNames = []
				for (var childField=0; childField<ChildFieldCount; childField++){ 
					if (ListViewSummaryData[listInfo].hasOwnProperty(`ChildField${childField}`)){
						ChildFieldNames.push(ListViewSummaryData[listInfo][`ChildField${String(childField)}`][0])
					}
					else {
						ChildFieldNames = ""
					}
				}
			}
			let HeaderInfo = {
				RecordCount: "# Records",
				InstanceCount: "# Instances",
				Name: ViewName.split("::")[1],
				ChildFieldNames: ChildFieldNames,
				GroupArr: groupArr,
				GroupCount: groupArr.length,
				RowCount: ItemCount,
				FieldType: FieldType,
				ChildFieldCount: ChildFieldCount
			}
			return HeaderInfo
		}
		else {
			console.log(ListData.error, ListData)
		}
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting List Items")
			return {}
		}
		console.log("Fetch Error :-S", error)
	}
}

const ListViewItemsAsync = async function(url = webServer, datasetID, ListViewID, startIndex, signal){
	try {

		let FullListObject = {}
		let command = "query"
		var listQuery = `query ListView.Item where ListView=${ListViewID} sort=RecDesc Row=${startIndex} count=${ListBlocks} ReturnObjects`
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + listQuery
		})
		let status = await response.status
		if (status !== 200) {
			console.log(`Looks like there was a problem. Status Code: ${response.status}`)
			return
		}
		let ListData = await response.json()
		// Examine the text in the response
		if(ListData.error === "0"){
			FullListObject = parseResponse(ListData)
		}
		else {
			console.log(ListData.error, ListData)
		}
		return FullListObject	
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting List Items")
			return {}
		}
		console.log("Fetch Error :-S", error)
	}
}

const MatrixViewData = function (url = webServer, datasetID, MatrixViewID, signal) {
	return new Promise((resolve) => {
		var ReturnData = {}
		var command = "query"
		var strQuery = "query MatrixView.Summary where MatrixView=" + MatrixViewID + " ReturnObjects"
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " +
                        response.status)
					return
				}
				// Examine the text in the response
				response.json().then(data1 => {
					if (data1.error === "0"){
						const MatrixViewSummaryData = parseResponse(data1)
						for (var matrixInfo in MatrixViewSummaryData) {
							var ColCount = (typeof MatrixViewSummaryData[matrixInfo].ColCount === "undefined") ? "" : parseInt(MatrixViewSummaryData[matrixInfo].ColCount, 10)
							var ColFieldName = (typeof MatrixViewSummaryData[matrixInfo].ColFieldName === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].ColFieldName)
							var ColFieldID = (typeof MatrixViewSummaryData[matrixInfo].ColFieldID === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].ColFieldID)
							var RowCount = (typeof MatrixViewSummaryData[matrixInfo].RowCount === "undefined") ? "" : parseInt(MatrixViewSummaryData[matrixInfo].RowCount, 10)
							var FloodMin = (typeof MatrixViewSummaryData[matrixInfo].FloodMin === "undefined") ? "" : MatrixViewSummaryData[matrixInfo].FloodMin
							var FloodMax = (typeof MatrixViewSummaryData[matrixInfo].FloodMax === "undefined") ? "" : MatrixViewSummaryData[matrixInfo].FloodMax
							var RowFieldName = (typeof MatrixViewSummaryData[matrixInfo].RowFieldName === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].RowFieldName)
							var RowFieldID = (typeof MatrixViewSummaryData[matrixInfo].RowFieldID === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].RowFieldID)
							var ViewName = (typeof MatrixViewSummaryData[matrixInfo].ViewName === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].ViewName)
							var MatrixHeader = (typeof MatrixViewSummaryData[matrixInfo].MatrixHeader === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].MatrixHeader)
						}                                
						let HeaderInfo = {
							RecordCount: "# Records",
							Name: ViewName.split("::")[1],
							RowCount: RowCount,
							ColCount: ColCount,
							ColFieldName: ColFieldName,
							ColFieldID: ColFieldID,
							RowFieldName: RowFieldName,
							RowFieldID: RowFieldID,
							MatrixHeader: MatrixHeader,
							FloodMax: FloodMax,
							FloodMin: FloodMin
						}
						ReturnData.HeaderInfo = HeaderInfo
						let FullMatrixObject = {}
						for (var index = 0; index < RowCount; index += MatrixBlocks) {
							for (var colIndex = 0; colIndex < ColCount; colIndex += MatrixBlocks) {
								var matrixQuery = "query MatrixView.Item where MatrixView=" + MatrixViewID + " sort=RecDesc Row=" + index + " count=" + MatrixBlocks + " Col=" + colIndex + " count=" + MatrixBlocks + " ReturnObjects"
								fetch(url + "?" + "VpPubId=" + datasetID, {
									signal,
									method: "post",
									mode: "cors",
									headers: {
										"Accept-Encoding":"gzip, deflate",
										"Content-Type": "application/x-www-form-urlencoded"
									},
									body: command + "=" + matrixQuery
								})
									.then(response => {
										if (response.status !== 200) {
											console.log("Looks like there was a problem. Status Code: " +
										response.status)
											return
										}
										// Examine the text in the response
										response.json().then((MatrixData) => {
											if (MatrixData.error === "0"){

												if (FullMatrixObject !== {}){
													FullMatrixObject = deepmerge(FullMatrixObject, parseResponse(MatrixData))
												}
												else {
													FullMatrixObject = parseResponse(MatrixData)
												}
											}
											else {
												console.log(MatrixData.error, MatrixData)
											}
											if (Object.keys(FullMatrixObject).length === RowCount + 2 && (colIndex + MatrixBlocks >= ColCount)) {
												ReturnData.Matrix = FullMatrixObject
												resolve(ReturnData)
											}
										})
									})
									.catch(error => {
										if (error.name == "AbortError"){
											console.log("aborting Matrix Items")
											return {}
										}
										console.log("Fetch Error :-S", error)
									})
							}
						}
					}
					else {
						console.log(data1.error, data1)
					}
				})
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Matrix Summary")
					return 0
				}
				console.log("Fetch Error :-S", error)
			})
	})
}

const MatrixViewDataAsync = async function (url = webServer, datasetID, MatrixViewID, signal) {
	try {
		var command = "query"
		var strQuery = "query MatrixView.Summary where MatrixView=" + MatrixViewID + " ReturnObjects"
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
		let status = await response.status
		if (status !== 200) {
			console.log(`Looks like there was a problem. Status Code: ${status}`)
			return
		}
		// Examine the text in the response
		let MatrixData = await response.json()
		if (MatrixData.error === "0"){
			const MatrixViewSummaryData = parseResponse(MatrixData)
			for (var matrixInfo in MatrixViewSummaryData) {
				var ColCount = (typeof MatrixViewSummaryData[matrixInfo].ColCount === "undefined") ? "" : parseInt(MatrixViewSummaryData[matrixInfo].ColCount, 10)
				var ColFieldName = (typeof MatrixViewSummaryData[matrixInfo].ColFieldName === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].ColFieldName)
				var ColFieldID = (typeof MatrixViewSummaryData[matrixInfo].ColFieldID === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].ColFieldID)
				var RowCount = (typeof MatrixViewSummaryData[matrixInfo].RowCount === "undefined") ? "" : parseInt(MatrixViewSummaryData[matrixInfo].RowCount, 10)
				var FloodMin = (typeof MatrixViewSummaryData[matrixInfo].FloodMin === "undefined") ? "" : MatrixViewSummaryData[matrixInfo].FloodMin
				var FloodMax = (typeof MatrixViewSummaryData[matrixInfo].FloodMax === "undefined") ? "" : MatrixViewSummaryData[matrixInfo].FloodMax
				var RowFieldName = (typeof MatrixViewSummaryData[matrixInfo].RowFieldName === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].RowFieldName)
				var RowFieldID = (typeof MatrixViewSummaryData[matrixInfo].RowFieldID === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].RowFieldID)
				var ViewName = (typeof MatrixViewSummaryData[matrixInfo].ViewName === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].ViewName)
				var MatrixHeader = (typeof MatrixViewSummaryData[matrixInfo].MatrixHeader === "undefined") ? "" : String(MatrixViewSummaryData[matrixInfo].MatrixHeader)
			}                                
			let HeaderInfo = {
				RecordCount: "# Records",
				Name: ViewName.split("::")[1],
				RowCount: RowCount,
				ColCount: ColCount,
				ColFieldName: ColFieldName,
				ColFieldID: ColFieldID,
				RowFieldName: RowFieldName,
				RowFieldID: RowFieldID,
				MatrixHeader: MatrixHeader,
				FloodMax: FloodMax,
				FloodMin: FloodMin
			}
			return HeaderInfo
		}
		else {
			console.log(MatrixData.error, MatrixData)
		}
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Matrix Data")
			return {}
		}
		console.log("Fetch Error :-S", error)
	}
}
const MatrixViewItemsAsync = async function (url = webServer, datasetID, MatrixViewID, rowIndex, colIndex, signal) {
	let FullMatrixObject = {}
	let command = "query"
	try {
		
		var matrixQuery = `query MatrixView.Item where MatrixView=${MatrixViewID} sort=RecDesc Row=${rowIndex} count=${MatrixBlocks} Col=${colIndex} count=${MatrixBlocks} ReturnObjects`
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + matrixQuery
		})
		let status = await response.status
		if (status !== 200) {
			console.log("Looks like there was a problem. Status Code: " + status)
			return
		}
		// Examine the text in the response
		let MatrixData = await response.json()
		if (MatrixData.error === "0"){
			FullMatrixObject = parseResponse(MatrixData)
		}
		else {
			console.log(MatrixData.error, MatrixData)
		}
		return FullMatrixObject
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Matrix Items")
			return {}
		}
		console.log("Fetch Error :-S", error)
	}
}
const BrowserViewData = (url = webServer, datasetID, browserViewID, signal) => {
	return new Promise((resolve) => {
		var command = "query"
		var strQuery = "query Browserview.Summary where browserview=" + browserViewID
		return fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
			.then((response) => {
				return response.json()
			})
			.then((data) => {
				resolve(data)
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Browser View Summary")
					return {}
				}
				console.warn("Fetch Error :-S", error)
				return null
			})
	})
}

const BrowserViewDataAsync = async (url = webServer, datasetID, browserViewID, signal) => {
	try {
		var command = "query"
		var strQuery = "query Browserview.Summary where browserview=" + browserViewID
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
		let data = await response.json()
		return parseResponse(data)
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Browser View Summary")
			return {}
		}
		console.warn("Fetch Error :-S", error)
		return null
	}
}

const VPQueryAsync = async (url = webServer, datasetID, strQuery, id, signal) => {
	try {
		var command = "query"
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + strQuery
		})
		let data = await response.json()
		data.id = id
		return data
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Browser View Summary")
			return {}
		}
		console.warn("Fetch Error :-S", error)
		return null
	}
}

const FieldArray = function(url = webServer, datasetID, signal){
	return new Promise(function(resolve){
		var command = "query"
		fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=query Field.Names, Field.ID ReturnObjects"
		})
			.then(response =>{
				if (response.status !== 200) {
					console.log("Looks like there was a problem. Status Code: " +
			response.status)
					return
				}
				// Examine the text in the response
				response.json().then(data => {
					if (data.error === "0"){
						const fields = parseResponse(data)
						var fieldArr = []
						for (var field in fields) {
							fieldArr.push({
								label: fields[field].Name,
								value: fields[field].ID
							})
						}
						resolve(fieldArr)
					}
					else {
						console.log(data.error, data)
					}
				})
					.catch(error => {
						if (error.name == "AbortError"){
							console.log("aborting Field Array")
							return {}
						}
						console.log("Fetch Error :-S", error)
					})
			})
	})
}

const FieldArrayAsync = async function(url = webServer, datasetID, signal){
	try {
		var command = "query"
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=query Field.Names, Field.ID ReturnObjects"
		})
		let status = await response.status
		if (status !== 200) {
			console.log("Looks like there was a problem. Status Code: " + status)
			return []
		}
		let data = await response.json()
		// Examine the text in the response
		if (data.error === "0"){
			const fields = parseResponse(data)
			var fieldArr = []
			for (var field in fields) {
				fieldArr.push({
					label: fields[field].Name,
					value: fields[field].ID
				})
			}
			return fieldArr
		}
		else {
			if (data.Error.includes("Failed with error 0")){
				alert("Error Connecting to Patstat - contact Doug")
			}
			else {
				alert("Unknown Error getting data - contact Jon (who may contact Doug)")
			}
			console.log(data.Error)
		}
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Field Array")
			return {}
		}
		console.log("Fetch Error :-S", error)
	}
}
const DetailFieldArrayAsync = async function(url = webServer, datasetID, signal){
	try {
		var command = "query"
		let response = await fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=query Field.Names, Field.ID where Field.Metatag='Dashboard' ReturnObjects"
		})
		let status = await response.status
		if (status !== 200) {
			console.log("Looks like there was a problem. Status Code: " + status)
			return []
		}
		let data = await response.json()
		// Examine the text in the response
		if (data.error === "0"){
			const fields = parseResponse(data)
			var fieldArr = []
			for (var field in fields) {
				fieldArr.push({
					label: fields[field].Name,
					value: fields[field].ID
				})
			}
			return fieldArr
		}
		else {
			console.log(data.error, data)
		}
	}
	catch(error) {
		if (error.name == "AbortError"){
			console.log("aborting Field Array")
			return {}
		}
		console.log("Fetch Error :-S", error)
	}
}

const RecordNumbers = (url = webServer, datasetID, VPQuery, signal) => {
	return new Promise(function(resolve){
		var command = "query"
		VPQuery = VPQuery.replace(/ /g, "+")
		VPQuery = VPQuery.replace(/=/g, "%3D")
		VPQuery = VPQuery.replace(/#/g, "%23")
		return fetch(url + "?" + "VpPubId=" + datasetID, {
			signal,
			method: "post",
			mode: "cors",
			headers: {
				"Accept-Encoding":"gzip, deflate",
				"Content-Type": "application/x-www-form-urlencoded"
			},
			body: command + "=" + VPQuery
		})
			.then((response) => {
				return response.json()
			})
			.then((data) => {
				if (data.error === "0"){
					const records = parseResponse(data)
					resolve(records)
				}
				else {
					console.log(data.error, data)
				}
			})
			.catch(error => {
				if (error.name == "AbortError"){
					console.log("aborting Record Numbers")
					return {}
				}
				console.warn("Fetch Error :-S", error)
				return null
			})
	})
}
async function sha256(message) {
	// encode as UTF-8
	const msgBuffer = new TextEncoder("utf-8").encode(message)                    

	// hash the message
	const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer)

	// convert ArrayBuffer to Array
	const hashArray = Array.from(new Uint8Array(hashBuffer))

	// convert bytes to hex string
	const hashHex = hashArray.map(b => ("00" + b.toString(16)).slice(-2)).join("")
	return hashHex
}

function parseResponse(response){
	let oTempArray = null
	let results = null
	if (typeof(response) === "string"){
		results = JSON.parse(response).results
	}
	else {
		results = response.results
	}
	try {
		let parsedResponse = JSON.parse(results)
		if (parsedResponse.hasOwnProperty("success")){
			if (parsedResponse.success){
				try {
					
					oTempArray = JSON.parse(parsedResponse.output)
				}
				catch(err){
					oTempArray = parsedResponse.output
				}
			}
			else {
				return "Failed to fetch"
			}
		}
		else {
			oTempArray = parsedResponse
		}
	}
	catch(err){
		oTempArray = results
	}
	return oTempArray
} 

export {
	TitleWindowSummary,
	TitleWindowSummaryAsync,
	TitleWindowItems,
	TitleWindowItemsAsync,
	DetailWindowSummary,
	DetailWindowSummaryAsync,
	DetailWindowItems,
	DetailWindowItemsAsync,
	DetailWindowRecords,
	DatasetDetails,
	DatasetDetailsAsync,
	DatasetsAvailable,
	ListViewData,
	ListViewDataAsync,
	ListViewItemsAsync,
	MatrixViewData,
	MatrixViewDataAsync,
	MatrixViewItemsAsync,
	BrowserViewData,
	BrowserViewDataAsync,
	VPQueryAsync,
	BrowserContents,
	FieldArray,
	FieldArrayAsync,
	DetailFieldArrayAsync,
	FieldedRecordView,
	RawRecordField,
	GetDataStoredInDataset,
	GetDataStoredInDatasetAsync,
	RecordNumbers
}